const handleRipple = (element: HTMLElement, ev: MouseEvent): void => {
    const rippleElement = document.createElement('span');
    let currentDiameter = 1;
    let currentOpacity = 0.65;
    const animationHandler = setInterval(animateRippleSpread, 8);
    applyRippleStyle();

    function applyRippleStyle(): void {
        const elementCoordinates: DOMRect = element.getBoundingClientRect();
        const offsetY = ev.clientY - elementCoordinates.y;
        const offsetX = ev.clientX - elementCoordinates.x;

        rippleElement.style.position = 'absolute';
        rippleElement.style.height = '5px';
        rippleElement.style.width = '5px';
        rippleElement.style.borderRadius = '100%';
        rippleElement.style.backgroundColor = '#f2f2f2';
        rippleElement.style.left = `${offsetX}px`;
        rippleElement.style.top = `${offsetY}px`;
        (ev.target as HTMLElement).appendChild(rippleElement);
    }

    function animateRippleSpread(): void {
        const maximalDiameter = 50;
        if (currentDiameter <= maximalDiameter) {
            currentDiameter++;
            currentOpacity -= 0.65 / maximalDiameter;
            rippleElement.style.transform = `scale(${currentDiameter})`;
            rippleElement.style.opacity = `${currentOpacity}`;
        } else {
            rippleElement.remove();
            clearInterval(animationHandler);
        }
    }
};

const vRipple = {
    mounted: (el: HTMLElement): void => {
        el.style.position = 'relative';
        el.style.overflow = 'hidden';
        el.addEventListener('click', (ev: MouseEvent) => handleRipple(el, ev));
    }
};

export default vRipple;
